<template>
  <div class="footer_container" v-show="event_show">
    <div class="float-left">
      <strong>Copyright © 2021-2022.</strong>
      All rights reserved.
    </div>
    <div class="float-right"><b>Version</b> 1.5.27</div>
  </div>
</template>

<script>
export default {
  name: "footers",
  data() {
    return { event_show: true };
  },
  mounted() {
    // 注册监听事件
    let scope = this;
    this.emit.on("event_footer_show", function (bShow) {
      scope.event_show = bShow;
    });
  },
  unmounted() {
    //移除监听事件
    this.emit.off("event_footer_show");
  },
};
</script>

<style scoped>
.footer_container {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #dee2e6;
  background-color: #fff;
  height: 32px;
  padding: 8px;
  box-sizing: border-box;
}

.float-left {
  color: #869099;
  float: left;
  bottom: 4px;
  position: relative;
}

.float-right {
  color: #869099;
  float: right;
  bottom: 4px;
  position: relative;
}
</style>
